<!--
  ChangelogDialogHeader.vue
  
  Header component for the changelog dialog with title, version, and close button.
  
  @component
-->
<template>
  <div class="sticky top-0 z-10 bg-gradient-to-r from-brand-500 to-brand-400 px-6 py-4">
    <div class="flex items-center justify-between">
      <div>
        <h2 class="text-2xl font-bold text-white">What's New</h2>
        <p class="text-white/80 text-sm">Version {{ currentVersion }}</p>
      </div>
      <button
        type="button"
        class="text-white/80 hover:text-white transition-colors p-2 hover:bg-charcoal-800/10 rounded-lg"
        aria-label="Close dialog"
        @click="$emit('close')"
      >
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
/**
 * Props for the ChangelogDialogHeader component
 */
interface Props {
  /** Current application version to display */
  currentVersion: string
}

defineProps<Props>()

defineEmits<{
  /** Emitted when close button is clicked */
  close: []
}>()
</script>
